import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { apiUrl, baseUrl } from '../../../utils/apis';

export const loginAuth = createApi({
  reducerPath: 'authApi',
  baseQuery: fetchBaseQuery({
    baseUrl
  }),
  tagTypes: ['Auth'],
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: apiUrl.login,
        method: 'POST',
        body: credentials
      }),
      invalidatesTags: ['Auth']
    }),
    signUp: builder.mutation({
      query: (bodyData) => ({
        url: apiUrl.signUp,
        method: "POST",
        body: bodyData,
      }),
    }),

    sendResetEmail: builder.mutation({
      query: (body) => ({
        url: apiUrl.sendResetEmail,
        method: 'POST',
        body: body
      }),
      invalidatesTags: ['Auth']
    }),

    verifyOtp: builder.mutation({
      query: (body) => ({
        url: apiUrl.verifyOtp,
        method: 'POST',
        body: body
      }),
      invalidatesTags: ['Auth']
    }),

    resetPassword: builder.mutation({
      query: (body) => ({
        url: apiUrl.resetPassword,
        method: 'POST',
        body: body
      }),
      invalidatesTags: ['Auth']
    })
  })
});

export const {
  useLoginMutation,
  useSendResetEmailMutation,
  useVerifyOtpMutation,
  useResetPasswordMutation, useSignUpMutation
} = loginAuth;
